import { IAdobeClickEvent, IAdobeProductClickEvent, IAdobeProductPageEvent } from '../types/tracking';

declare global {
  interface Window {
    adobeAnalytics?: {
      track: (eventType: string, event: IAdobeClickEvent | IAdobeProductPageEvent | IAdobeProductClickEvent) => void;
    };
  }
}

const sendAdobeEvent = (
  event: IAdobeClickEvent | IAdobeProductPageEvent | IAdobeProductClickEvent,
  eventType = 'clickevent'
) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line
    console.log('tracking:', event);
  } else if (window.adobeAnalytics) {
    window.adobeAnalytics.track(eventType, event);
  }
};

export default sendAdobeEvent;
